export default "__VITE_ASSET__B_03ZlNG__"